import { toFlagRules } from './canAccess';
import { NavFlagKey, NavItem } from './types';

export type FlagDescriptor = { key: NavFlagKey; type: 'boolean' | 'json' };

/**
 * Derive the deduped list of Eppo flags that matter — the single source of
 * which flags the bootstrap must resolve. Covers both access gates
 * (`access.flag`) and flags read by dynamic titles (`titleFlags`).
 */
export const collectFlagKeys = (items: readonly NavItem[]): FlagDescriptor[] => {
    const descriptors = new Map<NavFlagKey, FlagDescriptor>();

    items.forEach((item) => {
        if (item.access.flag) {
            toFlagRules(item.access.flag).forEach((rule) => {
                descriptors.set(rule.key, { key: rule.key, type: rule.type ?? 'boolean' });
            });
        }

        item.titleFlags?.forEach((key) => {
            if (!descriptors.has(key)) {
                descriptors.set(key, { key, type: 'boolean' });
            }
        });
    });

    return [...descriptors.values()];
};
